/**
 * API Configuration Utility
 * Provides environment-aware API URLs that work in both development and production
 */

/**
 * Get the API base URL based on current environment
 * - In production: Uses the same host as the website (proxied by Vite/Nginx)
 * - In development: Uses relative path (proxied by Vite to localhost:3001)
 */
export function getApiBaseUrl(): string {
  // Always use relative path - Vite proxy will handle routing in dev
  // In production, your reverse proxy (Nginx/Caddy) should handle /api routing
  return '/api';
}

/**
 * Get the WebSocket URL based on current environment
 * - In production: Uses the same host as the website with appropriate protocol
 * - In development: Uses relative path (proxied by Vite to localhost:3001)
 */
export function getWebSocketUrl(): string {
  if (typeof window === 'undefined') {
    return 'ws://localhost:3000/ws';
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}/ws`;
}

/**
 * DEPRECATED: Do not use hardcoded localhost URLs
 * This constant is provided for migration purposes only
 */
export const LEGACY_LOCALHOST_URL = 'http://localhost:3001/api';
